import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Contact from "./AllAccountDetails/Contact";
import Jobs from "./AllAccountDetails/Jobs";
import PrimaryContacts from "./AllAccountDetails/PrimaryContacts";
import Activities from "./AllAccountDetails/Activities";
import Notes from "./AllAccountDetails/Notes";
import {
  Button,
  InfoText,
  InfoTimeCardAdv,
  StatusTags,
  Modal,
  LogoLoader,
  NewTab,
  InfoWrapper,
} from "../../../../components";
import { dateFormator, keyToTitle } from "../../../../utils";
import EditModal from "./Modals/EditModal";
// import {
//   getAccountActivityDetails,
//   getAccountCardsCount,
//   getAccountDetailsById,
// } from "../../../../redux/slices/accountDetails/accountDetailsApi";
import { convertFromUTC } from "../../../../utils/dateUtils";
import AgreementUploads from "./AllAccountDetails/AgreementUploads";
import { accountAgreementPerTermsOptions, accountPackageOptions, accountWarrantyOptions } from "../../../../assets/data/enumData";
import { formatWords2 } from "../../../../utils/stringUtils";
import { getAccountActivityDetails, getAccountCardsCount, getAccountDetailsById } from "../../../../redux/slices/accountDetails/accountDetailsAPi";

const companyStatus = {
  1: "Active",
  2: "Blocked",
};

const AllAccountDetails = () => {
  // const { uiid } = useParams();
  const location = useLocation();
  let { uiid } = location?.state || {};
  if (!uiid) uiid = sessionStorage.getItem("selectedCompanyUiid");
  const [openEditModal, setOpenEditModal] = useState(false);
  const navigate = useNavigate();
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [acccountActivities, setAccountActivities] = useState([]);
  const [jobCardCounts, setJobCardCounts] = useState({
    jobsOpened: 0,
    submitted: 0,
    interviewed: 0,
    selected: 0,
    confirmed: 0,
    start: 0,
  });

  const JobPostingStatus = {
    1: "Draft",
    2: "Active",
    3: "On Hold",
    4: "Hold by Client",
    5: "Interview L1",
    6: "Interview L2",
    7: "Interview L3",
    8: "Priority",
    9: "Filled",
    10: "Closed",
    11: "Agreement Sent",
    12: "Agreement Accepted",
  };
  const ApplicantSubStatus = {
    1: "shortlisted",
    2: "pipeline",
    3: "Submitted",
    4: "Review call by BDM",
    5: "BDM Interview",
    6: "Disqualified",
    7: "Hold",
    8: "Withdrawn",
    9: "Waiting for Writeup",
    10: "Submitted to Client",
    11: "Submitted To Vendor",
    12: "Shortlisted for Interview",
    13: "Interview Confirmation",
    14: "Interview Scheduled",
    15: "L1 Interview Scheduled",
    16: "L2 Interview Scheduled",
    17: "L3 Interview Scheduled",
    18: "L1 Interview Selected",
    19: "L2 Interview Selected",
    20: "L3 Interview Selected",
    21: "L1 Interview Rejected",
    22: "L2 Interview Rejected",
    23: "L3 Interview Rejected",
    24: "L1 Interview Re-Scheduled",
    25: "L2 Interview Re-Scheduled",
    26: "L3 Interview Re-Scheduled",
    27: "L1 Interview Feedback Pending",
    28: "L2 Interview Feedback Pending",
    29: "L3 Interview Feedback Pending",
    30: "Rejected By Client",
    31: "Selected but no response from the client",
    32: "Rejected after Client Selection",
    33: "Submitted to End Client",
    34: "Vendor Interview",
    35: "Vendor Interview Reject",
    36: "Client Interview",
    37: "Client Interview Select",
    38: "Client Interview Reject",
    39: "Client Interview Completed",
    40: "End Client Interview",
    41: "End Client Interview Completed",
    42: "Selected By Vendor",
    43: "Selected By Client",
    44: "Selected By End Client",
    45: "Rejected By Vendor",
    46: "Rejected by End Client",
    47: "Disqualified By Vendor",
    48: "Disqualified By Client",
    49: "Disqualified by End Client",
    50: "Hold By Vendor",
    51: "Hold By Client",
    52: "Hold by End Client",
    53: "Drop",
    54: "Position on Hold",
    55: "PW Interview Proposed By Buyer",
    56: "PW Interview Proposed By Supplier",
    57: "PW Interview Failed",
    58: "PW Interview Cancelled",
    59: "PW Interview Success",
    60: "Assignment Contract Sent",
    61: "Assignment Contract Verified",
    62: "Assignment Contract Rejected",
    63: "Confirmed",
    64: "Position Filled",
    65: "Backout",
    66: "Not Joined",
    67: "BGV Failed",
    68: "Got Pay Rate Confirmation",
    69: "Offer Withdrawn",
    70: "Negotiation",
    71: "Start",
    72: "Offer Sent",
    73: "Offer Accepted",
    74: "Offer Rejected",
    75: "Hold with Client",
    76: "Hold with Vendor",
  };

  const mergeAllCompanyActivities = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [
        {
          task: "Created",
          taskBy:
            account?.addedBy && account?.addedBy?.firstName
              ? formatWords2(account?.addedBy?.firstName)
              : formatWords2(account?.addedBy || ""),
          designation:
            account?.addedBy && account?.addedBy?.role?.name
              ? formatWords2(account?.addedBy.role.name)
              : "",
          taskDate: convertFromUTC(account?.addedOn),
          applicant: "N/A",
        },
      ];
    }

    const record = data[0];
    const clean = (arr) =>
      (arr || [])
        .flat(Infinity)
        .filter(
          (item) =>
            item &&
            !(
              typeof item === "object" &&
              !Array.isArray(item) &&
              Object.keys(item).length === 0
            )
        );

    const jobPostingGroups = record.jobPostingStatusHistory || [];
    const submissions = clean(record.submissionStatusHistory);
    const jobs = clean(record.jobActivities);

    const merged = [];

    jobPostingGroups.forEach((group) => {
      const postings = clean(group);
      postings.forEach((job) => {
        merged.push({
          type: "jobPostingCreated",
          addedOn: job.addedOn,
          addedBy: job.addedBy,
          jobPostId: job.jobCode,
          status: "CREATED",
          recruiter: job?.notifyTo?.map(rec => rec.firstName)?.join(", ")
        });
        const sortedStatusHistory = (job.statusHistory || []).slice().sort(
          (a, b) => new Date(a.addedOn) - new Date(b.addedOn)
        );
        sortedStatusHistory.forEach((sh) => {
          merged.push({
            ...sh,
            type: "jobPostingStatus",
            jobPostId: job.jobCode,
            recruiter: job?.notifyTo?.map(rec => formatWords2(rec.firstName))?.join(", ")
          });
        });
      });
    });

    jobs.forEach((job) => {
      merged.push({
        ...job,
        type: "job",
      });
    });

    submissions.forEach((sub) => {
      merged.push({
        ...sub,
        type: "submission",
        recruiter: formatWords2(sub?.addedBy?.firstName),
        jobPostId: sub?.jobPostId?.jobCode
      });
    });

    merged.sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn));

    const timeline = merged.map((sh) => {
      let taskBy = "";
      let designation = "";

      if (sh.addedBy) {
        if (typeof sh.addedBy === "object" && sh.addedBy.firstName) {
          taskBy = formatWords2(sh.addedBy.firstName);
          designation =
            formatWords2(sh.addedBy.role?.name) ||
            formatWords2(sh.addedBy.role);
        } else {
          taskBy = sh.addedBy.toString();
          designation = sh.addedBy?.role?.name || "";
        }
      }

      let task = "Account Added";

      if (sh.type === "jobPostingCreated") {
        task = `Job Created`;
      } else if (sh.type === "jobPostingStatus") {
        task = JobPostingStatus[sh.status] || sh.status;
      } else if (sh.type === "submission") {
        task = ApplicantSubStatus[sh.status] || sh.status;
      } else if (sh.type === "job") {
        task = "Account Added";
      }

      return {
        task,
        taskBy,
        designation,
        taskDate: convertFromUTC(sh.addedOn),
        applicant:
          sh?.candidateId && typeof sh?.candidateId === "object"
            ? formatWords2(sh?.candidateId.firstName) +
            " " +
            formatWords2(sh?.candidateId.lastName)
            : isNaN(sh?.candidateId)
              ? "N/A"
              : sh?.candidateId,
        jobPostId: sh?.jobPostId,
        recruiter: sh?.recruiter
      };
    });

    if (account?.addedOn) {
      timeline.push({
        task: "Account Created",
        taskBy:
          account?.addedBy && account?.addedBy?.firstName
            ? formatWords2(account?.addedBy?.firstName)
            : formatWords2(account?.addedBy || ""),
        designation:
          account?.addedBy && account?.addedBy?.role?.name
            ? formatWords2(account?.addedBy.role.name)
            : "",
        taskDate: convertFromUTC(account?.addedOn),
        applicant: "N/A",
      });
    }

    return timeline;
  };
  const activities = mergeAllCompanyActivities(acccountActivities);

  const infoCardDetails = [
    // { title: "Jobs Opened", value: "200" },
    // { title: "Submitted", value: "60" },
    // { title: "Inteviewed", value: "3" },
    // { title: "Selected", value: "60" },
    // { title: "Confirmed", value: "47" },
    // { title: "Start", value: "23" },
    { title: "Jobs Opened", value: jobCardCounts?.jobsOpened },
    { title: "Submitted", value: jobCardCounts?.submitted },
    { title: "Inteviewed", value: jobCardCounts?.interviewed },
    { title: "Selected", value: jobCardCounts?.selected },
    { title: "Confirmed", value: jobCardCounts?.confirmed },
    { title: "Start", value: jobCardCounts?.start },
  ];
  const jobPostMenus = [
    // {
    //   title: "Info",
    //   page: <Info />,
    //   type: "main",
    //   id: "allaccountdetails_info",
    // },
    {
      title: "Contact",
      page: <Contact companyId={account?.uiid} />,
      type: "main",
      id: "allaccountdetails_contact",
    },
    {
      title: "Jobs",
      page: <Jobs companyId={account?.uiid} />,
      type: "main",
      id: "allaccountdetails_jobs",
    },
    {
      title: "Primary Contacts",
      page: <PrimaryContacts companyId={account?.uiid} />,
      type: "main",
      id: "allaccountdetails_primarycontacts",
    },
    {
      title: "Activities",
      page: <Activities activities={activities || []} />,
      type: "main",
      id: "allaccountdetails_activities",
    },
    {
      title: "Notes",
      page: <Notes companyId={account?.uiid} />,
      type: "main",
      id: "allaccountdetails_notes",
    },
    {
      title: "Agreement Uploads",
      page: <AgreementUploads companyId={account?.uiid} />,
      type: "main",
      id: "allaccountdetails_aggrementuploads",
    },
  ];
  // let generalJobDetails = [
  //   {
  //     website: "https://www.example.com",
  //     location: "Hyderabad, Telangana",
  //     industry: "Civil Engineer",
  //   },
  // ];
  const generalJobDetails = [
    {
      Website: account?.website || "-",
      Industry: formatWords2(account?.industry || "-"),
      Domain: account?.domain || "-",
      // Location: account?.location
      //   ? `${account.location.city || ""}, ${account.location.state || ""}, ${
      //       account.location.country || ""
      //     }`
      //   : "-",
      location: account?.location
        ? [
          account.location.city,
          account.location.state,
          account.location.country,
        ]
          .filter(Boolean)
          .join(", ")
        : "-",
    },
  ];

  // let secondaryDetails = [
  //   {
  //     "Created by": "Joseph",
  //     "Modified by": "Chandan T",
  //     "Created on": "10-01-2022",
  //     "Modified On": "10-01-2023",
  //   },
  // ];
  const secondaryDetails = [
    {
      "Created By": formatWords2(account?.addedBy?.firstName || "-"),
      "Created On": account?.addedOn
        ? dateFormator(convertFromUTC(account.addedOn), "date-month-year")
        : "-",
      "Modified By": formatWords2(account?.modified?.by || "-"),
      "Modified On": account?.modified?.on
        ? dateFormator(convertFromUTC(account.modified.on), "date-month-year")
        : "-",
    },
  ];
  
  const amountDetails = {
    Package: accountPackageOptions[account?.package] || "-",
    // Amount: "-",
    "Warranty Period": accountWarrantyOptions[account?.warranty] || "-",
    "Agreement Net Terms": accountAgreementPerTermsOptions[account?.agreementNetTerms] || "-",
  };

  const fetchAccountDetails = async () => {
    try {
      setLoading(true);
      const response = await getAccountDetailsById({
        coll: "Company",
        fil: { uiid: { type: "NONE", value: uiid } },
        ret: "uiid name website industry domain status addedBy addedOn modified location package amount warranty agreementNetTerms",
      });

      if (response?.data?.data) {
        setAccount(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching account details:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAccountCardCounts = async () => {
    try {
      const response = await getAccountCardsCount({
        coll: "JobPosting",
        fil: { companyId: { type: "COMPANY_JOBSTATUS_COUNT", value: uiid } },
        useAggregate: true,
      });

      if (response?.data?.data) {
        setJobCardCounts(response.data.data?.[0]);
      }
    } catch (error) {
      console.error("Error fetching account details:", error);
    }
  };
  useEffect(() => {
    if (uiid) fetchAccountDetails();
    if (uiid) fetchAccountCardCounts();
  }, []);

  const fetchAccountActivityDetails = async () => {
    try {
      setLoading(true);
      const response = await getAccountActivityDetails({
        coll: "Job",
        fil: {
          uiid: {
            type: "AG_COMPANY_ACTIVITIES",
            value: "",
            companyId: account?.uiid,
          },
        },
        extret: "uiid firstName role",
        useAggregate: true,
        extincl: "uiid name",
      });

      if (response?.data?.data) {
        // console.log(response.data.data[0].data, "getAccountActivityDetails");
        setAccountActivities(response.data.data?.[0]?.data);
      }
    } catch (error) {
      console.error("Error fetching account details:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (account) fetchAccountActivityDetails();
  }, [account]);
  useEffect(() => {
    if (!uiid) {
      navigate("/ats/account-details?account-details=all-accounts", {
        replace: true,
      });
    }
  }, [uiid, navigate]);
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("selectedCompanyUiid");
    };
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LogoLoader />
      </div>
    );
  }
  if (!account)
    return (
      <div className="p-10 text-center text-gray-500">
        No account details found for this UIID.
      </div>
    );

  return (
    <div className="flex flex-col gap-5 flex-1">
      <div className="flex justify-between items-center mr-4 mt-3">
        <Button
          title="Accounts"
          color="black"
          variant="text"
          size="md"
          fromLeft
          icon="arrow_left_alt"
          className="self-start text-md font-semibold"
          onClick={() => {
            navigate("/ats/account-details?account-details=all-accounts");
          }}
        />
        <div className="flex gap-2">
          <Button
            variant="outlined"
            title={"Edit"}
            icon={"edit_square"}
            onClick={() => setOpenEditModal(true)}
          />
        </div>
      </div>

      <div className="flex justify-between items-center gap-1 mx-1">
        <div className="flex gap-2 items-center">
          <h6 className="subtitle-reg ml-3 mr-1">{formatWords2(account?.name || "")}</h6>
          <p className=" text-xs font-[600] text-gray-400 mr-3">
            ({dateFormator(account?.addedOn, "date-month-year")})
          </p>
          <StatusTags
            icon
            size="lg"
            tag={companyStatus[account?.status] || ""}
          />
        </div>
      </div>
      <div className=" mx-3 grid grid-cols-5 lg:grid-cols-4 gap-5 inner-section p-4 rounded">
        {Object.entries(generalJobDetails[0]).map(([key, value]) => {
          return (
            <InfoText
              size="md"
              key={key}
              title={keyToTitle(key)}
              value={value}
            />
          );
        })}
      </div>
      <div className="mx-3 grid grid-cols-7 md:grid-cols-4 gap-5 inner-section p-4 rounded">
        {Object.entries(secondaryDetails[0]).map(([key, value]) => {
          return (
            <InfoText
              key={key}
              size="md"
              title={keyToTitle(key)}
              value={value}
            />
          );
        })}
      </div>
      <div className="mx-3 grid grid-cols-7 md:grid-cols-4 gap-5 inner-section p-4 rounded">
        {Object.entries(amountDetails).map(([key, value]) => {
          return (
            <InfoText
              key={key}
              size="md"
              title={keyToTitle(key)}
              value={value}
            />
          );
        })}
      </div>

      {/* <div className="grid grid-cols-6 gap-4 mx-3"> */}
      <InfoWrapper>
        {infoCardDetails.map((item) => (
          <InfoTimeCardAdv
            title={item?.title}
            value={item?.value}
            variant={"text"}
            color={"primary"}
            size="sm"
          />
        ))}
      </InfoWrapper>
      {/* </div> */}

      <div className="flex-1 mx-3 rounded-xl">
        <NewTab
          tabs={jobPostMenus}
          color="gray"
          variant="text"
          activeVariant="text"
          mode="url"
          tabId="account-details"
        />
      </div>

      <Modal
        isOpen={openEditModal}
        onClose={() => setOpenEditModal(false)}
        title={"Edit"}
        titleColor={"primary"}
        width="max-w-4xl"
      >
        <EditModal
          onCancel={() => setOpenEditModal(false)}
          companyData={{
            uiid: account?.uiid || null,
            name: account?.name || "-",
            location: account?.location || {},
            website: account?.website || "-",
            industry: account?.industry || "-",
            addedOn: account?.addedOn || null,
            status: account?.status || null,
            package: account?.package || null,
            amount: account?.amount || null,
            warranty: account?.warranty || null,
            agreementNetTerms: account?.agreementNetTerms || null,
          }}
          onSuccess={() => fetchAccountDetails()}
        />
      </Modal>
    </div>
  );
};

export default AllAccountDetails;
